export enum KeywordType {
    USER_NAME, USER_EMAIL, COMPANY_NAME
}

export const KeywordTypeList = [
    {
        type: KeywordType.USER_NAME,
        name: '회원명'
    },
    {
        type: KeywordType.USER_EMAIL,
        name: '이메일'
    },
    {
        type: KeywordType.COMPANY_NAME,
        name: '회사명'
    }
]